<template>
    <div style="display: flex;width: 100%;display: flex;flex-wrap: wrap;">
        <div class="fileItem" v-if="isUpload">
            <van-icon v-if="isUpload" class="delClz" style="visibility: hidden" name="clear" size="20px" />
            <div class="uploadIcon" @click="triggerUpload">
                <van-icon style="vertical-align: middle;" name="plus" size="3em"/>
            </div>
            <form style="display: none;" ref="upload">
                <input :id="refName" :ref="refName" type="file" name="uploadFile" @change="upload" multiple>
            </form>
        </div>
        <div class="fileItem" v-for="(item,index) in files">
            <van-icon v-if="isUpload" class="delClz" name="clear" size="20px" @click="deleteFile(item)"/>
            <img v-if="item.fileType === 0" width="80" height="80" :src="item.thumbnailUrl" @click="showImage(index)"/>
            <img v-if="item.fileType === 1" :src="item.thumbUrl" width="80" height="80" style="margin-left: 5px;"
                 @click="showPdf(item)"/>
            <img v-if="item.fileType === 2" :src="item.thumbUrl" width="80" height="80" style="margin-left: 5px;"
                 @click="downFile(item)"/>
            <img v-if="item.fileType === 3" :src="item.thumbUrl" width="80" height="80" style="margin-left: 5px;"
                 @click="downFile(item)"/>
            <img v-if="item.fileType === 4" :src="item.thumbUrl" width="80" height="80" style="margin-left: 5px;"
                 @click="showVideo(item)"/>
            <img v-if="item.fileType === 5" :src="item.thumbUrl" width="80" height="80" style="margin-left: 5px;"
                 @click="downFile(item)"/>
            <!--<img v-else width="80" height="80" :src="icFile" @click="downFile(item)"/>-->
            <!--<p>{{item.fileName | ellipsis}}</p>-->
        </div>

        <van-popup
                v-model="previewPdf"
                closeable
                close-icon="close"
                position="top"
                :overlay="true"
                :style="{ height: '100%' }"
        >
            <iframe style="width: 100%; height:900px" :src="pdfSrc"></iframe>
        </van-popup>
        <van-popup
                v-model="previewVideo"
                :overlay="true"
                closeable
                close-icon="close"
                position="top"
                :style="{ height: '100%' }"
        >
            <div style="display: flex;justify-content: center;height: 100%;align-items: center">
                <video :src="videoSrc" controls="controls" style="width: 100%;height: 100%">
                    您的浏览器不支持视频预览，请使用Chrome内核的浏览器，谢谢！
                </video>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import {getOssFiles, delFile, ossUploads} from '@/api/loanInfo'
    import icFile from '@/assets/home/ic_file.png'
    import {mapGetters} from 'vuex'
    import {ImagePreview} from 'vant'
    import {word, excel, ppt, pdf, mp4} from '@/utils/iconBase64'

    const imageReg = /\.(jpg|JPG|jpeg|JPEG|png|PNG|)$/;
    const docReg = /\.(doc|DOC|docx|DOCX|)$/;
    const xlsReg = /\.(xls|XLS|xlsx|XLSX|)$/;
    const pptReg = /\.(ppt|PPT|pptx|PPTX|)$/;
    const videoReg = /\.(mp4|MP4|m4v|M4V|)$/;
    const pdfReg = /\.(pdf|PDF|)$/;

    export default {
        name: 'files_upload',
        props: {
            applyId: {
                type: String,
                default: ''
            },
            groupCode: {
                type: Number,
                default: ''
            },
            refName: {
                type: String,
                default: ''
            },
            isUpload: {
                type: Boolean,
                default: false,
            }
        },
        computed: mapGetters([
            'auditStatus',
            'applyInfo',
        ]),
        data() {
            return {
                previewVideo: false,
                previewPdf: false,
                pdfSrc: '',
                videoSrc: '',
                showUpload: true,
                loading: false,
                finished: false,
                read: true,
                images: [],
                files: [],
                icFile: icFile
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData() {
                this.images = []
                this.getFileList()
            },
            getFileList() {
                let self = this
                let params = {
                    applyId: this.applyId,
                    customer: this.applyInfo.customerId,
                    groupCode: this.groupCode
                }
                getOssFiles(params).then(res => {
                    if (res.success) {
                        let pics = []
                        let documents = []
                        self.images = []
                        self.finished = true
                        self.loading = false
                        res.pageObj.result.forEach(item => {
                            // 图片
                            if (imageReg.test(item.fileSuffix)) {
                                self.images.push(item.fileUrl)
                                item.fileType = 0
                                pics.push(item)
                            } else {
                                // 文件类
                                // item.fileUrl = this.baseUrl + '/file/downloadFile?fileId=' + item.fileId + "&fileUri=" + item.fileUri
                                if (pdfReg.test(item.fileSuffix)) {
                                    item.fileType = 1
                                    item.thumbUrl = pdf
                                } else if (docReg.test(item.fileSuffix)) {
                                    item.fileType = 2
                                    item.thumbUrl = word
                                } else if (xlsReg.test(item.fileSuffix)) {
                                    item.fileType = 3
                                    item.thumbUrl = excel
                                } else if (videoReg.test(item.fileSuffix)) {
                                    item.fileType = 4
                                    item.thumbUrl = mp4
                                } else if (pptReg.test(item.fileSuffix)) {
                                    item.fileType = 5
                                    item.thumbUrl = ppt
                                }
                                documents.push(item)
                            }
                        })
                        //合并文件（排序图片和文件）
                        self.files = pics.concat(documents);
                    }
                })
            },
            async upload(e) {
                let file = e.target.files
                let self = this
                self.loadings()
                let successCount=0;
                for(var i=0;i<file.length;i++){
                    let formData = new FormData()
                    formData.append('applyId', self.applyId)
                    formData.append('groupCode', self.groupCode)
                    formData.append('customerId', self.applyInfo.customerId)
                    formData.append('file', file[i])
                    await ossUploads(formData).then(res => {
                        if (res.success) {
                            successCount++;
                        }
                    }).catch(err => {
                        self.closeLoadings()
                    })
                }
                if(successCount>0){
                    self.closeLoadings()
                    self.$toast('操作完成，上传成功：' + successCount )
                    self.getFileList()
                }
            },
            deleteFile(file) {
                this.$dialog.confirm({
                    title: '删除',
                    message: '是否确认删除当前文件?'
                }).then(() => {
                    let data = {
                        customerFileId: file.customerFileId
                    }
                    delFile(data).then(res => {
                        this.$toast(res.msg)
                        this.getFileList()
                    })
                }).catch(() => {
                    // on cancel
                })
            },
            showImage(position) {
                const instance = ImagePreview({
                    images: this.images,
                    lazyLoad: true,
                    maxZoom: 12,
                    startPosition: typeof position === 'number' ? position : 0
                })
            },
            loadings() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '正在上传...'
                })
            },
            closeLoadings() {
                this.$toast.clear()
            },
            resetInputFile() {
                let file = document.getElementById(this.refName)
                file.value = ''
            },
            triggerUpload() {
                this.$refs[this.refName].dispatchEvent(new MouseEvent('click'))
            },
            downFile(file) {
                this.$dialog.confirm({
                    title: '下载文件',
                    message: '是否确认下载『' + file.fileName + '』?'
                }).then(() => {
                    window.open(file.fileUrl, '_blank')
                }).catch(() => {
                    // on cancel
                })
            },
            showPdf(data) {
                /*this.pdfSrc = data.url
                this.previewPdf = true*/
                window.open(data.url,'_blank')
            },
            showVideo(data) {
                this.videoSrc = data.url
                this.previewVideo = true
            }
        }
    }
</script>

<style scoped>
    .uploadIcon {
        height: 80px;
        width: 80px;
        line-height: 80px;
        border: 1px dashed #afb1b3;
    }

    .fileItem {
        width: 33.3%;
        display: flex;
        text-align: center;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;
        justify-content: center;
    }

    .delClz {
        left: 40px;
        top: 10px;
    }
</style>
